'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const stylesByVariant = {
    primary: styled.css `
    color: ${({ theme }) => theme.designTokens.buttonPrimaryTextColor};
    background: ${({ theme }) => theme.designTokens.buttonPrimaryBackgroundColor};
    &:hover,
    &.hover {
      background: ${({ theme }) => theme.designTokens.buttonPrimaryHoverBackgroundColor};
    }
    &:focus,
    &.focus {
      background: ${({ theme }) => theme.designTokens.buttonPrimaryFocusBackgroundColor};
    }
  `,
    secondary: styled.css `
    background: ${({ theme }) => theme.designTokens.buttonSecondaryBackgroundColor};
    color: ${({ theme }) => theme.designTokens.buttonSecondaryTextColor};
    border: ${({ theme }) => theme.designTokens.buttonSecondaryBorder};
    &:hover,
    &.hover {
      border: ${({ theme }) => theme.designTokens.buttonSecondaryHoverBorder};
    }
    &:focus,
    &.focus {
      border: ${({ theme }) => theme.designTokens.buttonSecondaryFocusBorder};
    }
  `,
    rounded: styled.css `
    border-radius: 30px;
  `,
    'rounded-outline': styled.css `
    color: ${({ theme }) => theme.designTokens.buttonOutlineTextColor};
    border: ${({ theme }) => theme.designTokens.buttonOutlineBorder};
    &:hover,
    &.hover {
      color: ${({ theme }) => theme.designTokens.buttonOutlineHoverTextColor};
      border: ${({ theme }) => theme.designTokens.buttonOutlineBorderHover};
    }
    &:focus,
    &.focus {
      color: ${({ theme }) => theme.designTokens.buttonOutlineFocusTextColor};
      border: ${({ theme }) => theme.designTokens.buttonOutlineBorderFocus};
    }
  `,
    transparent: styled.css `
    background: transparent;
    border: 0;
    color: ${({ theme }) => theme.designTokens.buttonSecondaryTextColor};
    &:hover,
    &.hover {
      color: ${({ theme }) => theme.designTokens.buttonOutlineHoverTextColor};
    }
  `,
};
const stylesBySize = {
    s: styled.css `
    line-height: ${({ theme }) => theme.designTokens.buttonSmallLineHeight};
    padding: ${({ hasIconWithoutText, theme }) => hasIconWithoutText
        ? theme.designTokens.buttonSmallPaddingWithIconOnly
        : theme.designTokens.buttonSmallPaddingWithText};
  `,
    m: styled.css `
    line-height: ${({ theme }) => theme.designTokens.buttonMediumLineHeight};
    padding: ${({ hasIconWithoutText, theme }) => hasIconWithoutText
        ? theme.designTokens.buttonMediumPaddingWithIconOnly
        : theme.designTokens.buttonMediumPaddingWithText};
  `,
    l: styled.css `
    line-height: ${({ theme }) => theme.designTokens.buttonLargeLineHeight};
    padding: ${({ hasIconWithoutText, theme }) => hasIconWithoutText
        ? theme.designTokens.buttonLargePaddingWithIconOnly
        : theme.designTokens.buttonLargePaddingWithText};
  `,
    xl: styled.css `
    line-height: ${({ theme }) => theme.designTokens.buttonXLargeLineHeight};
    padding: ${({ hasIconWithoutText, theme }) => hasIconWithoutText
        ? theme.designTokens.buttonXLargePaddingWithIconOnly
        : theme.designTokens.buttonXLargePaddingWithText};
  `,
};
const Button = styled__default.default.button `
  font: inherit;
  letter-spacing: 0;
  white-space: nowrap;
  margin: 0;
  display: inline-block;
  position: relative;
  &:focus,
  &.focus {
    outline: none;
  }
  vertical-align: middle;
  cursor: pointer;
  border: ${({ theme }) => theme.designTokens.buttonBorder};
  border-radius: ${({ theme }) => theme.designTokens.buttonBorderRadius};
  font-size: ${({ theme }) => theme.designTokens.buttonFontSize};
  font-family: ${({ theme }) => theme.designTokens.buttonFontFamily};
  font-weight: ${({ theme }) => theme.designTokens.buttonFontWeight};

  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
  ${({ size }) => stylesBySize[size]}
  ${({ active, theme }) => active &&
    `
  border: ${theme.designTokens.buttonOutlineBorderActive} !important;
  box-shadow: 0px 0px 0 1px ${theme.designTokens.buttonOutlineTextColor} !important;
  color: ${theme.designTokens.buttonOutlineTextColor} !important;
  `}
  ${({ variant }) => {
    switch (variant) {
        case 'rounded':
            return [...stylesByVariant.primary, ...stylesByVariant.rounded];
        case 'rounded-secondary':
            return [...stylesByVariant.secondary, ...stylesByVariant.rounded];
        case 'rounded-outline':
            return [...stylesByVariant.secondary, ...stylesByVariant.rounded, ...stylesByVariant['rounded-outline']];
        default:
            return stylesByVariant[variant];
    }
}}

  &&:disabled,
  &&.disabled {
    &,
    &:hover,
    &.hover {
      background: ${({ theme }) => theme.designTokens.buttonDisabledBackgroundColor};
      color: ${({ theme }) => theme.designTokens.buttonDisabledTextColor};
      cursor: not-allowed;
    }
  }
`;
const Styled = {
    Button,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
